module.exports = __webpack_public_path__ + "assets/img/dkban.5e86ccc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pagesInvestment/dkban.png
// module id = gClr
// module chunks = 128